export default {
  COVERAGE_LIST: [],
  COVERAGE_WORK_TYPES: [],
  WORK_TYPES: [],
  COVERAGE_POST_CODES: [],
  FOUND_LOCATIONS: [],
  FOUND_COVERAGE_REGIONS: [],
  SELECTED_COVERAGE_AREAS: [],
  SELECTED_COVERAGE: null,
}
